import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material"
import React from "react"
import { WSIcons } from "../../commonFunctions/iIcons"
import { WSTabs } from "../../Components/Tabs/WSTabs"
import { FormProvider, useForm } from "react-hook-form"
import { OpenSurcharge } from "./OpenSurcharge"

export const SurCharge:React.FC<any>=React.memo(({open,onClose})=>{
    const methods = useForm();
    const { handleSubmit, control, register } = methods;
    const tabs = [
        { label: "Surcharge Type", content:""},
        { label: "Open Surcharge", content: <OpenSurcharge/>},
        
        
      ];

      const onSubmit = async (data: any) => {
        debugger;
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };
    return(
        <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            width: '80vw',
            height: '80vh',
          },
        }}
      >
        <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>   
        <DialogTitle sx={{ backgroundColor: 'green' }}>
          <Grid display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" color="white">
              Apply Surcharge
            </Typography>
            <IconButton >
              <WSIcons.CloseIcon sx={{ color: 'white' }} onClick={onClose}/>
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
         
          <Grid container spacing={2} sx={{mt:2}}>
            {/* First Box */}
            <Grid item xs={12} sm={6}>
              <Grid sx={{ border: '1px solid grey', borderRadius: 1, overflow: 'hidden',height:"26rem"}}>
              <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />

              </Grid>
            </Grid>

            {/* Second Box */}
            <Grid item xs={12} sm={6}sx={{mt:6}}>
              <Grid sx={{ border: '1px solid grey', borderRadius: 1, overflow: 'hidden' }}>
                
                <Grid sx={{ padding: 2, height: '23rem' }} />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <Grid container alignItems="center" sx={{ backgroundColor: "#333", padding: "1rem" }}>
  {/* Left Icon */}
  <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-start" }}>
    <WSIcons.GTranslateIcon sx={{ color: "white" }} />
  </Grid>

  {/* Center Finish Button */}
  <Grid item xs={4} sx={{ display: "flex", justifyContent: "center" }}>
    <Button
      variant="outlined"
      sx={{borderColor:"green",color:"white"}}
      onClick={onSubmit}
    >
      Apply
    </Button>
  </Grid>

  {/* Right Remove Button */}
  <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
    <Button
      variant="outlined"
      sx={{borderColor:"green",color:"white"}}
     
    >
      Remove
    </Button>
  </Grid>
</Grid>
</form>
</FormProvider>
      </Dialog>

      
    </>
    )
})